/** @typedef {import('@/models/CreateProfile').User} User */
import { supabase } from '@/lib/supabase';
import { createProfile } from '@/models/CreateProfile';

/** 
 * DBからUsers取得
 * @param {Object} user
 * @returns {Promise<Map<number, User>>} idをキーとしたMap
 */
export async function getAllUsers() {
    try {
        const { data, error } = await supabase
            .from('profiles')
            .select('*')
            .select();

        if (error) {
            throw error;
        } else {
            return new Map(
                data.map(row => {
                    const user = createProfile(row);
                    return [user.id, user];
                })
            )
        }
    } catch (error) {
        console.error('Error fetching users:', error);
        return;
    }
}